import { Measurement } from 'schemas/MeasurementSchema'

export type ReviewData = {
  header: Measurement
  contents: Measurement[]
}

export const defaultReviewData = ({
  header: ({} as any) as Measurement,
  contents: []
} as any) as ReviewData
